import type { LucideIcon } from 'lucide-react';

/** A short fact behind its icon, for the list's row and the pane's header; nothing when empty. */
export function IconFact(props: {
  icon: LucideIcon;
  label: string;
  text: string | null;
}): React.JSX.Element | null {
  if (props.text === null || props.text === '') return null;
  const Icon = props.icon;
  return (
    <span className="icon-fact">
      <Icon aria-label={props.label} role="img" />
      {props.text}
    </span>
  );
}
